import { useState } from "react";
import { ArrowLeft, Mail } from "lucide-react";
import { useNavigate } from "react-router-dom";

export default function EsqueciSenhaPage() {
  const [email, setEmail] = useState("");
  const [isSubmitted, setIsSubmitted] = useState(false);
  const navigate = useNavigate();

  const handleSubmit = () => {
    setIsSubmitted(true);
    // Lógica de recuperação de senha aqui
  };

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="flex items-center mb-6">
          <button
            onClick={() => navigate("/login")}
            className="mr-4 p-2 text-gray-600 hover:text-gray-800"
          >
            <ArrowLeft size={20} />
          </button>
          <div className="flex-1 text-center"></div>
        </div>

        {!isSubmitted ? (
          <>
            <div className="text-center mb-6">
              <div className="mx-auto w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                <Mail size={32} className="text-blue-900" />
              </div>
              <h2 className="text-2xl font-bold text-gray-900 mb-2">
                Esqueceu sua senha?
              </h2>
              <p className="text-gray-600">
                Digite seu e-mail e enviaremos instruções para redefinir sua senha.
              </p>
            </div>

            <div className="space-y-4">
              <input
                type="email"
                placeholder="Seu e-mail"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                className="w-full px-4 py-3 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-900"
              />

              <button
                onClick={handleSubmit}
                className="w-full bg-blue-900 text-white py-3 rounded-md font-semibold hover:bg-blue-800 transition-colors"
              >
                Enviar instruções
              </button>
            </div>
          </>
        ) : (
          <div className="text-center">
            <div className="mx-auto w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mb-4">
              <Mail size={32} className="text-green-600" />
            </div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">
              E-mail enviado!
            </h2>
            <p className="text-gray-600 mb-6">
              Enviamos as instruções para <strong>{email}</strong>. 
              Verifique sua caixa de entrada e spam.
            </p>
            <button
              onClick={() => navigate("/login")}
              className="w-full bg-blue-900 text-white py-3 rounded-md font-semibold hover:bg-blue-800 transition-colors"
            >
              Voltar ao login
            </button>
          </div>
        )}

        <p className="text-center text-sm text-gray-600 mt-6">
          Lembrou da senha?{" "}
          <span
            onClick={() => navigate("/login")}
            className="text-blue-900 underline cursor-pointer hover:text-blue-700"
          >
            Faça login
          </span>
        </p>
      </div>
    </div>
  );
}
